// @ts-nocheck
// ========================================
// モバイル専用スタイル定義
// ========================================

import { CARD_SIZE, LAYOUT } from './breakpoints';

/**
 * モバイル用スタイル
 * useIsMobile() で条件分岐して適用
 */
const mobileStyles = {
  // ========================================
  // 共通レイアウト
  // ========================================
  container: {
    overflow: 'auto', // モバイルではスクロール許可
  },

  header: {
    padding: LAYOUT.mobile.headerPadding,
    flexWrap: 'wrap',
    gap: '8px',
  },

  headerTitle: {
    fontSize: '18px',
    letterSpacing: '1px',
  },

  headerInfo: {
    fontSize: '12px',
    gap: '8px',
  },

  // ========================================
  // 対戦画面
  // ========================================

  // メインエリア（サイドパネルなし）
  mainArea: {
    flexDirection: 'column',
  },

  // ゲームボード（縦長レイアウト）
  // 3行: P2エリア | センターゾーン | P1エリア
  gameBoard: {
    padding: '4px',
    gap: '2px',
    gridTemplateRows: 'auto auto auto',
  },

  // プレイヤーエリア（1カラム、コンパクト）
  playerArea: {
    gridTemplateColumns: '1fr',
    gap: '2px',
    padding: '2px',
  },

  // 情報パネル（コンパクト・横並び）
  infoPanel: {
    padding: '6px 8px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: '4px',
    fontSize: '11px',
  },

  infoPanelItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
  },

  // モンスターゾーン（5スロット可変）
  monsterZone: {
    gap: '4px',
    minHeight: 'auto',
    padding: '0 4px',
  },

  // カードスロット（可変サイズ）
  cardSlot: {
    width: CARD_SIZE.mobile.slotWidth,
    height: CARD_SIZE.mobile.slotHeight,
    borderWidth: '1px',
    borderRadius: '4px',
  },

  // フィールドモンスター（可変サイズ）
  fieldMonster: {
    width: CARD_SIZE.mobile.slotWidth,
    height: CARD_SIZE.mobile.slotHeight,
    fontSize: CARD_SIZE.mobile.fontSize,
    borderRadius: '4px',
  },

  fieldMonsterName: {
    fontSize: 'clamp(7px, 2vw, 11px)',
    padding: '1px 2px',
  },

  fieldMonsterStats: {
    fontSize: 'clamp(7px, 2vw, 10px)',
    padding: '1px 2px',
  },

  // センターゾーン（コンパクト）
  centerZone: {
    gap: '8px',
    padding: '8px',
    flexWrap: 'wrap',
  },

  // フィールドカード/フェイズカードゾーン（超コンパクト）
  fieldPhaseZone: {
    padding: '2px 4px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '4px',
    minHeight: 'auto',
    background: 'rgba(20,20,40,0.6)',
    borderRadius: '6px',
    border: '1px solid rgba(107,76,230,0.2)',
  },

  fieldPhaseZoneContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: '8px',
    justifyContent: 'center',
    alignItems: 'center',
  },

  fieldPhaseZoneItem: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '2px',
  },

  fieldPhaseZoneLabel: {
    fontSize: '8px',
    marginBottom: '0',
    writingMode: 'vertical-rl',
    color: '#888',
  },

  fieldPhaseZoneSlot: {
    width: '36px',
    height: '48px',
    fontSize: '7px',
    borderRadius: '3px',
  },

  actionButton: {
    padding: '8px 12px',
    fontSize: '12px',
    minWidth: '80px',
  },

  // 手札エリア（横スクロール）
  handArea: {
    overflowX: 'auto',
    WebkitOverflowScrolling: 'touch',
    scrollSnapType: 'x mandatory',
    justifyContent: 'flex-start',
    gap: '6px',
    padding: '8px',
    minHeight: 'auto',
    marginLeft: '-8px',
    marginRight: '-8px',
    paddingLeft: '8px',
    paddingRight: '8px',
  },

  // 手札カード（横スクロール用）
  handCard: {
    flexShrink: 0,
    width: CARD_SIZE.mobile.handWidth,
    height: CARD_SIZE.mobile.handHeight,
    scrollSnapAlign: 'start',
    fontSize: CARD_SIZE.mobile.fontSize,
  },

  // ========================================
  // サイドパネル（モーダル化）
  // ========================================
  sidePanelButton: {
    position: 'fixed',
    bottom: '16px',
    right: '16px',
    width: '48px',
    height: '48px',
    borderRadius: '50%',
    background: 'linear-gradient(135deg, #6b4ce6 0%, #9d4ce6 100%)',
    color: '#fff',
    border: 'none',
    fontSize: '20px',
    boxShadow: '0 4px 15px rgba(107,76,230,0.5)',
    zIndex: 100,
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },

  sidePanelModal: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'rgba(0,0,0,0.9)',
    zIndex: 200,
    display: 'flex',
    flexDirection: 'column',
  },

  sidePanelContent: {
    flex: 1,
    overflow: 'auto',
    padding: '16px',
    background: 'rgba(15,15,30,0.98)',
  },

  sidePanelCloseButton: {
    position: 'absolute',
    top: '12px',
    right: '12px',
    width: '36px',
    height: '36px',
    borderRadius: '50%',
    background: 'rgba(255,255,255,0.1)',
    color: '#fff',
    border: 'none',
    fontSize: '18px',
    cursor: 'pointer',
  },

  // ========================================
  // タイトル画面
  // ========================================
  titleScreen: {
    padding: '16px',
  },

  titleText: {
    fontSize: '28px',
    marginBottom: '8px',
  },

  titleSubtext: {
    fontSize: '14px',
    marginBottom: '16px',
  },

  // セレクトボックス（縦並び）
  selectContainer: {
    flexDirection: 'column',
    gap: '12px',
    width: '100%',
    maxWidth: '300px',
  },

  selectGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    width: '100%',
  },

  selectLabel: {
    fontSize: '14px',
    fontWeight: 'bold',
  },

  select: {
    width: '100%',
    padding: '10px 12px',
    fontSize: '14px',
    borderRadius: '8px',
    background: 'rgba(30,30,60,0.9)',
    color: '#e0e0e0',
    border: '1px solid rgba(107,76,230,0.5)',
  },

  // ボタン（縦並び・幅100%）
  buttonContainer: {
    flexDirection: 'column',
    gap: '10px',
    width: '100%',
    maxWidth: '300px',
  },

  titleButton: {
    width: '100%',
    padding: '14px 24px',
    fontSize: '16px',
  },

  // ========================================
  // ショップ・コレクション画面
  // ========================================

  // タブ切り替え
  tabContainer: {
    display: 'flex',
    gap: '0',
    borderBottom: '1px solid rgba(107,76,230,0.3)',
    marginBottom: '12px',
  },

  tab: {
    flex: 1,
    padding: '10px 8px',
    fontSize: '13px',
    fontWeight: 'bold',
    background: 'transparent',
    color: '#888',
    border: 'none',
    borderBottom: '2px solid transparent',
    cursor: 'pointer',
    transition: 'all 0.2s',
  },

  tabActive: {
    color: '#e0e0e0',
    borderBottomColor: '#6b4ce6',
  },

  // カードグリッド（小さめ）
  cardGrid: {
    gridTemplateColumns: 'repeat(auto-fill, minmax(70px, 1fr))',
    gap: '8px',
  },

  // 2カラム→1カラム
  twoColumnLayout: {
    flexDirection: 'column',
    gap: '16px',
  },

  // ========================================
  // モーダル・ダイアログ
  // ========================================
  modal: {
    padding: '8px',
  },

  modalContent: {
    maxWidth: '100%',
    width: '100%',
    maxHeight: '90vh',
    overflow: 'auto',
    padding: '16px',
    borderRadius: '12px',
  },

  modalTitle: {
    fontSize: '18px',
    marginBottom: '12px',
  },

  // ========================================
  // SPトークン
  // ========================================
  spTokenContainer: {
    flexWrap: 'wrap',
    gap: '4px',
    justifyContent: 'center',
  },

  spToken: {
    width: '24px',
    height: '24px',
    fontSize: '11px',
  },

  // ========================================
  // ログ
  // ========================================
  log: {
    maxHeight: '80px',
    fontSize: '10px',
    padding: '6px',
  },

  // ========================================
  // ライフバー
  // ========================================
  lifeBar: {
    height: '20px',
  },

  lifeText: {
    fontSize: '11px',
  },
};

/**
 * デスクトップとモバイルのスタイルをマージするヘルパー
 * @param {Object} desktopStyle - デスクトップ用スタイル
 * @param {Object} mobileStyle - モバイル用スタイル
 * @param {boolean} isMobile - モバイルかどうか
 * @returns {Object} マージされたスタイル
 */
export const mergeStyles = (desktopStyle, mobileStyle, isMobile) => {
  if (!isMobile) return desktopStyle;
  return { ...desktopStyle, ...mobileStyle };
};

/**
 * 条件付きスタイル適用ヘルパー
 * @param {Object} baseStyle - ベーススタイル
 * @param {boolean} condition - 条件
 * @param {Object} conditionalStyle - 条件が真の時に適用するスタイル
 * @returns {Object} マージされたスタイル
 */
export const conditionalStyle = (baseStyle, condition, conditionalStyle) => {
  if (!condition) return baseStyle;
  return { ...baseStyle, ...conditionalStyle };
};

export default mobileStyles;
